import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';

import Axios from '@/assets/plugin/axios';
import checkResp from '@/assets/plugin/checkResp';
import handleError from '@/assets/plugin/handleError';

// sync the router with the vuex store.

Vue.use(Axios);
Vue.use(checkResp);
Vue.use(handleError);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/views/mobile/app.js